import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button, useDeviceType } from '@cian/ui-kit';
import { loadAllPromosAction } from '../../actions/promos';
import { SearchResultsEmpty } from '../../components/SearchResults';
import { TThunkDispatch } from '../../types/redux/thunk';

export const SearchResultsEmptyContainer = () => {
  const isDesktop = useDeviceType() === 'desktop';
  const dispatch: TThunkDispatch = useDispatch();

  const handleResetFilters = React.useCallback(() => {
    dispatch(loadAllPromosAction());
  }, [dispatch]);

  return (
    <SearchResultsEmpty
      isDesktop={isDesktop}
      action={
        <Button size="M" theme="fill_secondary" onClick={handleResetFilters}>
          Сбросить фильтры
        </Button>
      }
    />
  );
};
